import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import {
    TRANSLATION_A11Y_SHOW_NAVIGATION,
    TRANSLATION_A11Y_HIDE_NAVIGATION,
} from '@wdx/shared/utils';

@Component({
    selector: 'wdx-app-sidebar',
    templateUrl: './wdx-app-sidebar.component.html',
    styleUrls: ['./wdx-app-sidebar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxAppSidebarComponent {
    @Input() collapsed = false;

    @Output() wdxOnCollapsed = new EventEmitter(this.collapsed);

    readonly A11Y_SHOW_NAVIGATION = TRANSLATION_A11Y_SHOW_NAVIGATION;
    readonly A11Y_HIDE_NAVIGATION = TRANSLATION_A11Y_HIDE_NAVIGATION;

    toggle(): void {
        this.collapsed = !this.collapsed;
        this.wdxOnCollapsed.emit(this.collapsed);
    }
}
